export enum FormularioEnum {
	SGR_GuiaRemision = 'SGR-GUIA-ELECTRONICA',
}
